const ProjectCardData = [
  {
    imgsrc: "DSAPREP.png",
    title: "DSAPREP",
    text: "This is the Full-Stack Web app that allows users to practice DSA sheets instead of boring Excel Sheets.It consists of progress-tracking feature, enabling users to track their learning journey and resume from where they left off with a leaderboard system, encouraging users to strive for better performance",
    source: "http://dsaprep.onrender.com/",
    effct: "fade-right",
    tag1: "NodeJS",
    tag2: "ExpressJS",
    tag3: "EJS",
    tag4: "Firebase",
    tag5: "none",
    code: "/",
  },
  {
    imgsrc: "karigar.png",
    title: "Karigars-India",
    text: "This is the Full-Stack Project built with an aim to help Karigars to get the the exposure to the job Opprtunities easily & companies can also eaily hire the labours from here easily through the website itself.",
    source: "http://karigarsindia.onrender.com",
    effct: "fade-left",
    tag1: "NodeJS",
    tag2: "ExpressJS",
    tag3: "EJS",
    tag4: "Firebase",
    tag5: "none",
    code: "https://github.com/Amanverma1101/Karigars-India",
  },
  {
    imgsrc: "YT_Clone.png",
    title: "YouTube UI Clone",
    text: "Check out my this project which is basically the clone of the YouTube-UI website. Here you should also try to sarch for some content in the serch-box where i have used the YouTube Api to make the search bar Active.",
    source: "https://amanverma1101.github.io/YouTube-UI-Clone/",
    effct: "fade-right",
    tag1: "HTML",
    tag2: "CSS",
    tag3: "JavaScript",
    tag4: "none",
    tag5: "YouTube API",
    code: "https://github.com/Amanverma1101/YouTube-UI-Clone",
  },
  {
    imgsrc: "AirTicketBooking.png",
    title: "Air Ticket Booking",
    text: "Check out my this project which basically contains a reponsive Front-End User Interface of an Airline Ticket Booking Website. I have tried to make this webpage attractive by using CSS animations. ",
    source: "https://amanverma1101.github.io/Air-Ticket-Booking/",
    effct: "fade-left",
    tag1: "HTML",
    tag2: "CSS",
    tag3: "JavaScript",
    tag4: "none",
    tag5: "none",
    code: "https://github.com/Amanverma1101/Air-Ticket-Booking",
  },
  {
    imgsrc: "MusicPlayer.png",
    title: "Retro Music Player",
    text: "Check out my this project which is basically a Music Player. Here you could try playing different songs in a Serial, Repeated or in a Shuffled manner.",
    source: "https://amanverma1101.github.io/Music-Player/",
    effct: "fade-right",
    tag1: "HTML",
    tag2: "CSS",
    tag3: "JavaScript",
    tag4: "Bootstrap",
    tag5: "none",
    code: "https://github.com/Amanverma1101/Music-Player",
  },
  {
    imgsrc: "WA1.png",
    title: "Weather App",
    text: "Check out my this project which basically gives the Live Weather update of a Location. Here I have used the Weather Api to fetch the Live weather update of a Location. ",
    source: "https://amanverma1101.github.io/Weather-App/",
    effct: "fade-left",
    tag1: "HTML",
    tag2: "CSS",
    tag3: "JavaScript",
    tag4: "none",
    tag5: "Weather API",
    code: "https://github.com/Amanverma1101/Weather-App",
  },
];

export default ProjectCardData;